<template>
  <div class="intervals">
    <Interval
      v-for="(interval, intervalIndex) in serializedIntervals"
      :key="interval.key"
      :interval="interval"
      :with-prices="true"
      lazy-rules="ondemand"
      :remove-btn="intervals.length > min"
      @change="updateInterval({ index: intervalIndex, value: $event})"
      @remove="removeInterval(intervalIndex)"
    />
    <div class="intervals-actions text-right">
      <q-btn label="+" @click="addInterval" />
    </div>
  </div>
</template>

<script>
/**
 * @module PageArea/Component/Intervals
 * @requires Shared/Component/Interval
 * @listens module:Shared/Component/Interval#change
 * @listens module:Shared/Component/Interval#remove
 * @fires module:PageArea/Component/Intervals#add
 * @fires module:PageArea/Component/Intervals#change
 * @fires module:PageArea/Component/Intervals#remove
 * @vue-computed {Array.<Object>} serializedIntervals - Сериализованные интервалы
 *   для внешнего компонента отображения интервалов
 * @vue-prop {Array.<Object>} intervals - Интервалы
 * @vue-prop {Number} min - Минимально допустимое количество интервалов
 * @vue-event {void} add - Добавить интервал
 * @vue-event {Object} change - Обновить интервал
 * @vue-event {Number} remove - Удалить интервал
 * */

import Interval from 'Shared/Interval'

/**
 * Уникальный ключ для v-for
 * @type {Number}
 * */
let localUniqueKey = 0

export default {
  components: {
    Interval
  },
  props: {
    /**
     * Интервалы
     * @type {Array.<Object>}
     * */
    intervals: Array,
    /**
     *
     * @type {Number}
     * */
    min: Number
  },
  computed: {
    /**
     * Сериализованные интервалы для внешнего компонента отображения интервалов
     * @type {Array.<Object>}
     * */
    serializedIntervals() {
      return this.intervals.map(el => this.serializeInterval(el))
    }
  },
  methods: {
    /**
     * Сериализовать интервал для внешнего компонента отображения интервалов
     * @param {Object}
     * @returns {Object}
     * */
    serializeInterval({
      startTime, endTime, id, ...rest
    }) {
      return {
        key: id || ++localUniqueKey,
        from: startTime,
        to: endTime,
        ...rest
      }
    },

    /**
     * Десериализовать интервал из внешнего компонента отображения интервалов
     * @param {Object}
     * @returns {Object}
     * */
    deserializeInterval({ from, to, ...rest }) {
      return {
        startTime: from,
        endTime: to,
        ...rest
      }
    },

    /**
     * Обработчик на добвление интервала
     * @fires module:PageArea/Component/Intervals#add
     * */
    addInterval() {
      /**
       * Добавить интервал
       * @event module:PageArea/Component/Intervals#add
       * @type {void}
       * */
      this.$emit('add')
    },

    /**
     * Обработчик на обновление интервала
     * @fires module:PageArea/Component/Intervals#change
     * @listens module:Shared/Component/Interval#change
     * */
    updateInterval({ index, value }) {
      /**
       * Обновить интервал
       * @event module:PageArea/Component/Intervals#change
       * @type {Object}
       * */
      this.$emit('change', {
        index,
        value: this.deserializeInterval(value)
      })
    },

    /**
     * Обработчик на удаление интервала
     * @fires module:PageArea/Component/Intervals#remove
     * @listens module:Shared/Component/Interval#remove
     * */
    removeInterval(index) {
      /**
       * Удалить интервал
       * @event module:PageArea/Component/Intervals#remove
       * @type {Number}
       * */
      this.$emit('remove', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.intervals {
  max-width: 1000px;
  margin: auto;
}
</style>
